"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _logo = _interopRequireDefault(require("../logo"));
var _mainHeader = _interopRequireWildcard(require("../main-header"));
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
// Default implementation for Main header
// ======================================

const DefaultMainHeader = _ref => {
  let {
    homeUrl,
    isLoggedIn,
    onLogin,
    onLogout
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_mainHeader.default, null, /*#__PURE__*/_react.default.createElement(_mainHeader.HeaderCenter, null, /*#__PURE__*/_react.default.createElement(_logo.default, {
    url: homeUrl
  })), onLogin && !isLoggedIn && /*#__PURE__*/_react.default.createElement(_mainHeader.HeaderRight, null, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: _indexModule.default.link,
    onClick: onLogin
  }, "Sign in")), onLogout && isLoggedIn && /*#__PURE__*/_react.default.createElement(_mainHeader.HeaderRight, null, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: _indexModule.default.link,
    onClick: onLogout
  }, "Sign out")));
};
var _default = exports.default = DefaultMainHeader;